import { render } from "./PractitionerModal.vue?vue&type=template&id=3014781a"
import script from "./PractitionerModal.vue?vue&type=script&lang=js"
export * from "./PractitionerModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__